<template>
  <div class="ccui-app-container">
    <div class="ccui-advanced-search-wrapper ccui-clearfix">
      <!-- <div class="ccui-search-wrapper"> -->
      <el-search
        :formProp="formData"
        @search="search"
        :isShowSearch="isShowSearch"
        class="ccui-highsearch"
        :selectClear="true"
        :isShow="isShow"
      >
        <div class="ccui-tab-wrapper">
          <el-button
            :type="isFocus === 1 ? 'table-top-active' : 'table-top'"
            size="mini"
            >全部 ({{ totalNum }})</el-button
          >
        </div>
        <div class="ccui-extend-btn">
          <el-button
            size="mini"
            type="primary"
            ref="pcconcmat-new-item"
            @click="handleGoNew"
            icon="icon-ccui-add-sup"
            >新增物资合同</el-button
          >
        </div>
        <template slot="search">
          <el-input
            v-model="formData.projectName"
            clearable
            searchLabel="项目"
            placeholder="请输入项目查询"
          ></el-input>
          <el-input
            v-model="formData.procurementMethod"
            clearable
            searchLabel="采购方式取值"
            placeholder="请输入采购方式取值查询"
          ></el-input>
          <el-input
            v-model="formData.procurementMethodCode"
            clearable
            searchLabel="采购方式"
            placeholder="请输入采购方式查询"
          ></el-input>
          <el-input
            v-model="formData.procurementPlanCode"
            clearable
            searchLabel="采购计划总编号"
            placeholder="请输入采购计划总编号查询"
          ></el-input>
          <el-input
            v-model="formData.biddingCode"
            clearable
            searchLabel="招标编号"
            placeholder="请输入招标编号查询"
          ></el-input>
          <el-select
            v-model="formData.isFloatContractPrice"
            clearable
            placeholder="请选择是否浮动合同价格查询"
            searchLabel="是否浮动合同价格"
          >
            <el-option key="0" label="否" :value="0"></el-option>
            <el-option key="1" label="是" :value="1"></el-option>
          </el-select>
          <el-input
            v-model="formData.floatDesc"
            clearable
            searchLabel="浮动说明"
            placeholder="请输入浮动说明查询"
          ></el-input>
          <el-input
            v-model="formData.quoteBiddingResult"
            clearable
            searchLabel="引用招标结果"
            placeholder="请输入引用招标结果查询"
          ></el-input>
          <el-input
            v-model="formData.quoteBiddingResult2"
            clearable
            searchLabel="引用招标结果2"
            placeholder="请输入引用招标结果2查询"
          ></el-input>
        </template>
        <!-- 表单高级搜索 -->

        <el-input
          v-model="formData.projectName"
          clearable
          searchLabel="项目"
          placeholder="请输入项目查询"
          slot="searchItem1"
          style="width:160px"
        ></el-input>

        <el-input
          v-model="formData.procurementMethod"
          clearable
          searchLabel="采购方式取值"
          placeholder="请输入采购方式取值查询"
          slot="searchItem2"
          style="width:160px"
        ></el-input>

        <el-input
          v-model="formData.procurementMethodCode"
          clearable
          searchLabel="采购方式"
          placeholder="请输入采购方式查询"
          slot="searchItem3"
          style="width:160px"
        ></el-input>

        <el-input
          v-model="formData.procurementPlanCode"
          clearable
          searchLabel="采购计划总编号"
          placeholder="请输入采购计划总编号查询"
          slot="searchItem4"
          style="width:160px"
          formClass="ccui-pre-form-item"
        ></el-input>

        <el-input
          v-model="formData.biddingCode"
          clearable
          searchLabel="招标编号"
          placeholder="请输入招标编号查询"
          slot="searchItem5"
          style="width:160px"
        ></el-input>

        <el-select
          v-model="formData.isFloatContractPrice"
          clearable
          placeholder="请选择是否浮动合同价格查询"
          searchLabel="是否浮动合同价格"
          slot="searchItem6"
          style="width:160px"
          formClass="ccui-pre-form-item"
        >
          <el-option key="0" label="否" :value="0"></el-option>
          <el-option key="1" label="是" :value="1"></el-option>
        </el-select>

        <el-input
          v-model="formData.floatDesc"
          clearable
          searchLabel="浮动说明"
          placeholder="请输入浮动说明查询"
          slot="searchItem7"
          style="width:160px"
        ></el-input>

        <el-input
          v-model="formData.quoteBiddingResult"
          clearable
          searchLabel="引用招标结果"
          placeholder="请输入引用招标结果查询"
          slot="searchItem8"
          style="width:160px"
        ></el-input>

        <el-input
          v-model="formData.quoteBiddingResult2"
          clearable
          searchLabel="引用招标结果2"
          placeholder="请输入引用招标结果2查询"
          slot="searchItem9"
          style="width:160px"
          formClass="ccui-pre-form-item"
        ></el-input>
      </el-search>
    </div>
    <!-- 表格 -->
    <div class="ccui-multifunctional-table-wrapper">
      <el-table
        ref="multipleTable"
        :data="tableData"
        :fit="true"
        :row-style="rowClass"
        :cell-style="cellStyle"
        border
        class="ccui-multifunctional-table"
        @select-all="handleCheckAllChange"
        @select="handleCheckChange"
        @selection-change="handleSelectionChange"
        @header-dragend="tableTitleWidth"
        @sort-change="sortChange"
        max-height="9999"
        v-if="draggFlag"
      >
        <el-table-column type="selection" width="28"></el-table-column>
        <template v-for="(table, index) in tableTheadOptions">
          <el-table-column
            v-if="table.checked"
            :fixed="table.fixed || false"
            :key="index"
            :type="table.type"
            :label="table.label"
            :align="table.align || 'left'"
            :header-align="table.headerAlign || 'left'"
            :min-width="table.width"
            :prop="table.prop"
            :formatter="formatterList[table.formatterName]"
            :show-overflow-tooltip="true"
            border="true"
          >
          </el-table-column>
        </template>

        <el-table-column label="操作" width="127" fixed="right">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              ref="pcconcmat-item-detail"
              v-if="isShowDetail"
              @click="handleGoDetail(scope.$index, scope.row)"
              >查看</el-button
            >
            <el-button v-else size="mini" type="text" disabled>查看</el-button>
            <el-button
              v-if="isShowEdit"
              size="mini"
              type="text"
              ref="pcconcmat-edit-item"
              @click="handleGoEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
            <el-button v-else size="mini" type="text" disabled>编辑</el-button>
            <el-button
              v-if="true"
              size="mini"
              type="text"
              @click="handleDelete(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
          <template v-slot:header>
            <div class="ccui-multifunctional-table-wrapper-operation">
              <span>操作</span>
              <el-popover
                placement="right"
                popper-class="ccui-multifunctional-table-wrapper_setting__popover"
                trigger="click"
              >
                <el-checkbox
                  v-for="(e, i) in fixedTableThead"
                  :key="i"
                  :checked="e.checked"
                  disabled
                  class="ccui-popover-disabled"
                  >{{ e.label }}</el-checkbox
                >
                <div class="ccui-popover-line"></div>
                <draggable
                  :list="unfixedTableThead"
                  class="ccui-draggable"
                  @change="handleTableChange"
                >
                  <el-checkbox-group
                    v-for="(item, index) in unfixedTableThead"
                    v-model="item.checked"
                    :key="index"
                  >
                    <el-checkbox
                      :label="item"
                      :checked="item.checked"
                      :width="item.width"
                      :title="item.label"
                      @change="handleUpdate(item, index)"
                      >{{ item.label }}</el-checkbox
                    >
                  </el-checkbox-group>
                </draggable>
                <!-- <i
                  class="el-icon-s-tools ccui-multifunctional-table-wrapper_setting__icon"
                  slot="reference"
                ></i>-->
              </el-popover>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="ccui-table-footer" v-show="isShowPagination">
        <div class="ccui-operation">
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            style="margin-left:10px"
            @change="handleCheckAllChangeBottom"
            >全选</el-checkbox
          >
          <el-button
            v-show="isSelection"
            size="mini"
            type="default"
            @click="handleDelSelected"
            style="margin-right:10px"
            >批量删除</el-button
          >
          <el-export-button
            placement="bottom"
            @export-excel="handleExport"
            @export-pdf="handleExport('all')"
          ></el-export-button>
        </div>
        <div id="ccui-paging">
          <el-pagination
            :total="totalNum"
            :page-size="getLocalPageSize()"
            :current-page="pageNoCode"
            :page-sizes="[10, 20, 50, 100, 200, 500]"
            background
            layout="total, sizes, prev, pager, next, jumper"
            popper-class="ccui-paging-page-size-popper"
            @prev-click="handlePrev"
            @next-click="handleNext"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
          <el-button
            class="ccui-pagination-btn"
            size="mini"
            type="default"
            @click="handleSizeChange('none')"
            >确定</el-button
          >
        </div>
      </div>
    </div>
    <!-- 表格 end -->
  </div>
</template>

<script>
require("core-js/modules/es.object.assign");
require("core-js/modules/es.object.keys");
require("regenerator-runtime/runtime");
require("core-js/modules/es.object.values");
require("core-js/modules/es.object.set-prototype-of");
require("core-js/modules/es.array.find");
require("core-js/modules/es.array-buffer.is-view");
require("core-js/modules/es.weak-map");
require("core-js/modules/es.promise");
const ExcelJS = require("exceljs");
import { saveAs } from "file-saver";
import draggable from "vuedraggable";
import { postDeletePcConcMat, postGetList } from "../api/item-list";

import {
  setSessionItem,
  getSessionItem,
  removeSessionItem,
  ishasAgentId
} from "@/basa/utils";

export default {
  components: {
    draggable
  },
  name: "pcconcmat-item-list",
  data() {
    return {
      isShowDetail: true,
      isShowEdit: true,
      multiDataToEnd: {},
      singleDataToEnd: {},
      // 表格相关
      tableData: [], // 表格数据
      draggFlag: true,
      tableName: this.tableList.pcconcmatList, // 表格命名
      tableThead: [], // 表格数据
      // 锁定表格
      fixedTableThead: [
        {
          label: "序号",
          prop: "id",
          width: "38",
          checked: true,
          fixed: true,
          type: "index",
          resizable: false
        }
      ],
      // 非锁定表格
      unfixedTableThead: [
        {
          label: "项目",
          prop: "projectName",
          width: "62",
          checked: true
        },
        {
          label: "采购方式取值",
          prop: "procurementMethod",
          width: "62",
          checked: true
        },
        {
          label: "采购方式",
          prop: "procurementMethodCode",
          width: "62",
          checked: true
        },
        {
          label: "采购计划总编号",
          prop: "procurementPlanCode",
          width: "62",
          checked: true
        },
        {
          label: "招标编号",
          prop: "biddingCode",
          width: "62",
          checked: true
        },
        {
          label: "是否浮动合同价格",
          prop: "isFloatContractPrice",
          width: "36",
          checked: true,
          formatterName: "isFloatContractPriceHandler"
        },
        {
          label: "浮动说明",
          prop: "floatDesc",
          width: "62",
          checked: true
        },
        {
          label: "引用招标结果",
          prop: "quoteBiddingResult",
          width: "62",
          checked: true
        },
        {
          label: "引用招标结果2",
          prop: "quoteBiddingResult2",
          width: "62",
          checked: true
        }
      ],
      // 动态表格
      tableTheadOptions: [],
      // 弹框表格
      // popoverShow: false,
      selectRow: [],
      selectData: [],
      isFocus: 1,
      // 表格相关 end
      // 高级搜索数据 start
      formData: {
        projectName: "",
        procurementMethod: "",
        procurementMethodCode: "",
        procurementPlanCode: "",
        biddingCode: "",
        isFloatContractPrice: "",
        floatDesc: "",
        quoteBiddingResult: "",
        quoteBiddingResult2: ""
      }, // 高级搜索提交数据
      formDataSearch: "",
      localSearchData: {},
      isShowSearch: true,
      isShow: false,
      // 高级搜索数据 end
      isShowPagination: false, //无数据的不展示底部全选，批量删除
      // 全选以及页码
      totalNum: 0,
      total: 0,
      isIndeterminate: false,
      checkAll: false,
      value: "",
      pageNoCode: this.getLocalPageNo(),
      pageSizeCode: this.getLocalPageSize(),
      // isFist: false,
      // 全选以及页码 end
      // 表格数据删除相关
      delDemoId: "",
      content: "您确定要删除吗？",
      typeDel: "", //有关批量删除
      isSelection: false,
      // 表格数据删除相关 end
      // 排序入参所需字段
      sortord: "",
      sortprop: "",
      // 表格数据相关处理
      formatterList: {
        isFloatContractPriceHandler(row, col) {
          switch (row.isFloatContractPrice) {
            case 0:
              return "否";
            case 1:
              return "是";
          }
        },

        isCreated: false
      }
      // 表格数据相关处理 end
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      this.isShow = false;
      // this.getList();
      this.setTableWidth();
      this.renderTable();
      // this.isFist = false;
    },
    // 导出
    async handleExport(type) {
      let isFloatContractPriceObj = {
        0: "否",
        1: "是"
      };
      const wb = new ExcelJS.Workbook();
      const ws1 = wb.addWorksheet("第一页");
      const page1Row1 = ws1.addRow([
        "序号",
        "项目",
        "采购方式取值",
        "采购方式",
        "采购计划总编号",
        "招标编号",
        "是否浮动合同价格",
        "浮动说明",
        "引用招标结果",
        "引用招标结果2"
      ]);
      if (type === "all") {
        let res = await postGetList({
          pageNo: 1,
          userName: "",
          pageSize: 5000,
          sortprop: "",
          sortord: "",
          isDelete: 0
        });

        if (res.data.data.rows.length > 0) {
          res.data.data.rows.forEach((item, index) => {
            ws1.addRow([
              index + 1,
              item.projectName,
              item.procurementMethod,
              item.procurementMethodCode,
              item.procurementPlanCode,
              item.biddingCode,
              isFloatContractPriceObj[item.isFloatContractPrice],
              item.floatDesc,
              item.quoteBiddingResult,
              item.quoteBiddingResult2
            ]);
          });
        }
      } else {
        this.tableData.forEach((item, index) => {
          ws1.addRow([
            index + 1,
            item.projectName,
            item.procurementMethod,
            item.procurementMethodCode,
            item.procurementPlanCode,
            item.biddingCode,
            isFloatContractPriceObj[item.isFloatContractPrice],
            item.floatDesc,
            item.quoteBiddingResult,
            item.quoteBiddingResult2
          ]);
        });
      }
      ws1.columns = [
        { key: "id", width: 5 },
        { key: "projectName", width: 20 },
        { key: "procurementMethod", width: 20 },
        { key: "procurementMethodCode", width: 20 },
        { key: "procurementPlanCode", width: 20 },
        { key: "biddingCode", width: 20 },
        { key: "isFloatContractPrice", width: 20 },
        { key: "floatDesc", width: 20 },
        { key: "quoteBiddingResult", width: 20 },
        { key: "quoteBiddingResult2", width: 20 }
      ];
      page1Row1.font = { bold: true, color: { argb: "00489A" } };
      page1Row1.fill = { color: { argb: "000000" } };
      const buf = await wb.xlsx.writeBuffer();
      saveAs(new Blob([buf]), "物资合同.xlsx");
    },
    // 根据返回状态显示不同的文字颜色
    // eslint-disable-next-line no-unused-vars
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (this.selectRow.includes(rowIndex)) {
        return { "background-color": "transparent" };
      }
    },
    // 默认渲染表格
    renderTable() {
      const localTableData = localStorage.getItem(this.tableName)
        ? JSON.parse(localStorage.getItem(this.tableName))
        : [];
      let unfixedTableThead = this.unfixedTableThead.concat(
        this.fixedTableThead
      );
      let localTableDataStr = localTableData.map(
        ({ label, prop, formatter, align }) =>
          JSON.stringify({ label, prop, formatter, align })
      );
      let unfixedTableTheadStr = unfixedTableThead.map(
        ({ label, prop, width, formatter, align }) =>
          JSON.stringify({ label, prop, formatter, align })
      );

      if (localTableData.length === unfixedTableThead.length) {
        let flag = localTableDataStr.every(item =>
          unfixedTableTheadStr.includes(item)
        );
        if (flag) {
          // 完全相同
          this.tableTheadOptions = localTableData;
          this.tableThead = localTableData;
          this.unfixedTableThead = localTableData.filter(item => {
            return !this.fixedTableThead.find(
              cItem => item.prop === cItem.prop
            );
          });
        } else {
          // 长度相同但值不同
          this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);
          const comment = JSON.stringify(this.tableThead);
          localStorage.setItem(this.tableName, comment);
          const localTableData = JSON.parse(
            localStorage.getItem(this.tableName)
          );
          this.tableTheadOptions = localTableData;
        }
      } else {
        // 长度不同
        this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);
        const comment = JSON.stringify(this.tableThead);
        localStorage.setItem(this.tableName, comment);
        const localTableData = JSON.parse(localStorage.getItem(this.tableName));
        this.tableTheadOptions = localTableData;
      }
    },
    // 表格弹框拖拽触发
    handleTableChange(val) {
      this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);
      const comment = JSON.stringify(this.tableThead);
      localStorage.setItem(this.tableName, comment);
      const localTableData = JSON.parse(localStorage.getItem(this.tableName));
      this.tableTheadOptions = localTableData;
    },
    // 是否显示对应列
    handleUpdate(item, index) {
      for (let i = 0; i < this.unfixedTableThead.length; i++) {
        if (i === index) {
          this.unfixedTableThead.checked = !this.unfixedTableThead.checked;
        }
      }
      this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);
      const comment = JSON.stringify(this.tableThead);
      localStorage.setItem(this.tableName, comment);
      const localTableData = JSON.parse(localStorage.getItem(this.tableName));
      this.tableTheadOptions = localTableData;
    },
    // 渲染本地存储表格宽度
    setTableWidth() {
      const localTableData = JSON.parse(localStorage.getItem(this.tableName));
      if (localTableData) {
        for (let i = 0; i < this.tableTheadOptions.length; i++) {
          if (this.tableTheadOptions[i].label === localTableData[i].label) {
            this.tableTheadOptions[i].width = localTableData[i].width;
          }
        }
      }
    },
    // 表格宽度更改存入
    tableTitleWidth(newWidth, oldWidth, column, event) {
      for (let i = 0; i < this.unfixedTableThead.length; i++) {
        if (this.unfixedTableThead[i].label === column.label) {
          this.unfixedTableThead[i].width = newWidth;
        }
      }
      this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);
      const comment = JSON.stringify(this.tableThead);
      localStorage.setItem(this.tableName, comment);
      this.tableTheadOptions = JSON.parse(localStorage.getItem(this.tableName));
      this.draggFlag = false;
      this.$nextTick(() => {
        this.draggFlag = true;
      });
    },
    handleSelectionChange(data) {
      this.selectData = data;
    },
    rowClass({ row, rowIndex }) {
      if (this.selectRow.includes(rowIndex)) {
        return { "background-color": "rgba(255,232,195,1) " };
      }
    },
    // 跳转编辑页
    handleGoEdit(index, row) {
      this.$router.push("/pcconcmat/edit-item/" + row.id);
    },
    // 跳转详情页
    handleGoDetail(index, row) {
      this.$router.push(`/pcconcmat/item-detail/${row.id}/${index}`);
    },
    // 跳转新增页
    handleGoNew() {
      this.$router.push("/pcconcmat/new-item");
    },
    // 删除列表数据
    handleDelete(index, row) {
      this.deleteLog();
      this.delDemoId = row.id;
    },
    // 删除弹框
    deleteLog() {
      this.$confirm("您确定要删除吗？", "删除确认", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        customClass: "ccui-message-box-custom"
      })
        .then(() => {
          if (this.typeDel == "all") {
            this.del(this.idArrSelected);
          } else {
            this.del([this.delDemoId]);
          }
        })
        .catch(() => {
          console.log("取消删除");
        });
    },
    // 批量删除并刷新列表
    handleDelSelected() {
      if (this.idArrSelected) {
        this.typeDel = "all";
        this.deleteLog();
      } else {
        this.$message({
          message: "请选择您要删除的数据",
          type: "warning"
        });
      }
    },
    // 上一页
    handlePrev() {
      console.log("上一页");
    },
    // 下一页
    handleNext() {
      console.log("下一页");
    },
    // 每页条数发生改变
    handleSizeChange(val) {
      this.pageNoCode = 1;
      if (val !== "none") {
        this.pageSizeCode = val;
        setSessionItem("pageSize", this.tableName, val);
      }
      this.getList(this.formDataSearch);
    },
    // 当前页发生改变
    handleCurrentChange(val) {
      let searchFormData = getSessionItem("pageNo", this.tableName) || {};
      setSessionItem("pageNo", this.tableName, {
        pageNo: val,
        searchForm: searchFormData.searchForm || {}
      });
      this.formDataSearch = {
        ...this.formDataSearch,
        ...searchFormData.searchForm
      };
      // 跳转翻页都会调这个方法
      this.pageNoCode = val;
      this.getList(this.formDataSearch);
    },
    // 高级搜索所需函数 start
    // 高级搜索展开按钮
    search(searchData) {
      this.pageNoCode = 1;
      this.formDataSearch = searchData;
      this.localSearchData = JSON.parse(JSON.stringify(searchData));
      setSessionItem("pageNo", this.tableName, {
        pageNo: this.pageNoCode,
        searchForm: this.localSearchData
      });
      this.getList(this.formDataSearch);
    },
    // 高级搜索 end
    // 列表数据请求
    getList(reqObj) {
      console.log(this.pageNoCode);
      let obj = {};
      obj = typeof reqObj == "object" ? reqObj : obj;
      obj.pageNo = this.pageNoCode;
      obj.business = "";
      obj.pageSize = this.pageSizeCode;
      obj.isDelete = 0;
      obj.isShowPageLoading = true;
      postGetList(obj)
        .then(res => {
          console.log(res);
          this.isShowPagination = res.data.data.recordsTotal > 0;
          this.tableData = res.data.data.rows;
          this.totalNum = res.data.data.recordsTotal;
          this.total = res.data.data.total;
          this.pageNoCode = res.data.data.pageNo; // 当前页
          //this.tableData.forEach((i, index) => {
          //  i.annualIncome = i.annualIncome
          //    ? "￥" + i.annualIncome.toFixed(2)
          //    : "";
          //  i.birthday = i.birthday ? i.birthday.substr(0, 10) : "";
          //  this.handleCheckChange(i);
          //});
        })
        .catch(e => {
          // console.log(e);
        });
    },
    // 删除数据请求
    del(arr) {
      postDeletePcConcMat({
        ids: arr,
        isShowLoading: true,
        loadingMessage: "删除中,请稍等..."
      }).then(res => {
        let { code, message } = res.data;
        this.$message({
          message: message,
          type: code === "0" ? "success" : "error",
          // duration: code === "0" ? 3000 : '',
          showClose: true,
          ccuiCustom: true
        });
        this.$refs.multipleTable.tableData.length <= 1 && --this.pageNoCode;
        this.getList();
        this.isSelection = false;
        this.isIndeterminate = false;
      });
    },
    // 全选
    handleCheckAllChange(val) {
      this.isIndeterminate = false;
      const arr = [];
      for (let i = 0; i < val.length; i++) {
        arr.push(val[i].id);
      }
      this.idArrSelected = arr;
      if (val.length) {
        this.isSelection = true;
      } else {
        this.isSelection = false;
      }
      if (typeof val === "boolean") {
        if (val) {
          this.toggleSelection(this.tableData);
        } else {
          this.toggleSelection([]);
        }
      } else {
        this.checkAll = val.length !== 0;
      }
    },
    // 底部全选
    handleCheckAllChangeBottom() {
      this.$refs.multipleTable.toggleAllSelection();
    },
    // 单个数据选中
    handleCheckChange(val) {
      const arr = [];
      for (let i = 0; i < val.length; i++) {
        arr.push(val[i].id);
      }
      this.idArrSelected = arr;
      if (val.length) {
        this.isSelection = true;
      } else {
        this.isSelection = false;
      }
      if (val.length > 0 && val.length < this.tableData.length) {
        this.isIndeterminate = true;
      } else if (val.length === this.tableData.length) {
        this.checkAll = true;
        this.isIndeterminate = false;
      } else {
        this.checkAll = false;
        this.isIndeterminate = false;
      }
    },
    toggleSelection(rows) {
      this.$refs.multipleTable.clearSelection();
      const arr = [];
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
          arr.push(row.id);
        });
        this.idArrSelected = arr;
      }
    },
    // 排序
    sortChange(params) {
      this.sortord = params.order;
      this.sortprop = params.prop;
      this.getList();
    },
    // 默认显示多少条
    getLocalPageSize() {
      return getSessionItem("pageSize", this.tableList.pcconcmatList) || 20;
    },
    // 读取当前页缓存
    getLocalPageNo() {
      let localData = getSessionItem("pageNo", this.tableList.pcconcmatList);
      return (localData && localData.pageNo) || 1;
    }
  },
  beforeRouteLeave(to, from, next) {
    removeSessionItem("pageNo");
    for (var key in this.$vnode.parent.componentInstance.cache) {
      delete this.$vnode.parent.componentInstance.cache[
        ishasAgentId(to.path, key)
      ];
    }
    next();
  },
  activated() {
    if (Object.keys(this.localSearchData).length > 0) {
      setSessionItem("pageNo", this.tableName, {
        pageNo: this.pageNoCode,
        searchForm: this.localSearchData
      });
    }
    let localData = getSessionItem("pageNo", this.tableList.pcconcmatList);
    let data = localData && localData.searchForm;
    this.getList({ ...this.formDataSearch, ...data });
  }
};
</script>
